<template>
  <v-dialog
    v-model="open"
    persistent
    scrollable
    max-width="640px"
    content-class="tw-rounded-3xl"
  >
    <v-card class="tw-relative tw-rounded-3xl tw-border-0 tw-shadow-md">
      <ModalHeader @close-modal="closeModal">
        {{ $t('admin.app.attendee_create_title') }}
      </ModalHeader>
      <v-divider />
      <v-card-text class="tw-p-0" style="max-height: 700px">
        <v-responsive class="tw-py-0">
          <v-container fluid class="pa-5">
            <UsersAttendeesForm
              ref="attendeesForm"
              v-model="form"
              compact
              show-basic-info
              :registry-id="registry.id"
              :error-alert.sync="errorAlert"
              :error-msg="errorMsg"
              :is-loading="isLoading"
              :has-password="!!registry.has_password"
              @submit-form="submitEvent"
            />
          </v-container>
        </v-responsive>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <AppBtn color="transparent" :disabled="isLoading" @click="closeModal">
          {{ $t('app.cancel') }}
        </AppBtn>
        <AppBtn
          color="primary"
          :loading="isLoading"
          @click="triggerSubmit"
        >
          {{ $t('app.save') }}
        </AppBtn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ModalHeader from '@/components/ModalHeader'
import AppBtn from '@/components/App/AppBtn.vue'
import UsersAttendeesForm from '@/views/Admin/Users/UsersAttendeesForm.vue'
import { AttendeeBase } from '@/models/Attendee'
import { RegistryParticipantsService } from '@/services/RegistryParticipantsService'
import { formErrorsHandler } from '@/utils/formErrorsHandler'

export default {
  components: {
    ModalHeader,
    AppBtn,
    UsersAttendeesForm,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    registry: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    form: AttendeeBase({}),
    isLoading: false,
    errorAlert: false,
    errorMsg: '',
  }),
  computed: {
    open: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.form = AttendeeBase({})
        this.errorAlert = false
      }
    },
  },
  methods: {
    closeModal() {
      this.open = false
    },
    triggerSubmit() {
      this.$refs.attendeesForm.submitEvent()
    },
    submitEvent(payload) {
      this.errorAlert = false
      this.isLoading = true

      RegistryParticipantsService.store(this.registry.id, payload)
        .then(() => {
          this.open = false
          this.$emit('created')
        })
        .catch((err) => {
          this.errorAlert = true
          this.errorMsg = formErrorsHandler(err)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>
